import { Text } from '@/components/ui/text'
import { ViewportFitContainer } from '@/components/ui/viewport-fit'
import {
  ConnectWallet,
  ReferralHistory,
  ReferralInformation,
  ReferralRewardSummary,
  RegisterReferral,
  WalletSelector,
} from '@/containers/referral-hub'
import { useLockBodyScroll, useWallet } from '@/hooks'
import { useLinkBtcWallet } from '@/hooks/wallets/use-link-btc-wallet'

import { useTranslation } from 'react-i18next'

export const ReferralHub = () => {
  const { isConnected } = useWallet()
  const { t } = useTranslation()
  useLockBodyScroll({
    skipOnMobile: true,
  })
  useLinkBtcWallet()

  if (!isConnected) return <ConnectWallet />
  return (
    <ViewportFitContainer skipOnMobile className='space-y-6 bg-transparent p-[1px] ring-transparent'>
      <div className='flex items-center gap-3'>
        <Text as='h6' size={22}>
          {t('title.REFERRAL_HUB')}
        </Text>
        <WalletSelector />
      </div>
      <div className='flex gap-4 flex-col md:flex-row'>
        <ReferralRewardSummary />
        <ReferralInformation />
        <RegisterReferral />
      </div>
      <ReferralHistory />
    </ViewportFitContainer>
  )
}
